import React from 'react';
import CustomRadio from '../../../common/components/CustomRadio';
import CustomTextInput from '../../../common/components/CustomTextInput';
import { FieldValidationErrorsType } from '../../../common/form/FrekulForm';

type MusicAlbumEditForm1ViewTitleInputFieldName = 'title'|'title_kana'|'title_en'|'is_multiple';

/**
 * リリースタイトル入力
 */
export default function MusicAlbumEditForm1ViewTitleInput({
  getValue,
  setValue,
  getErrors,
} : {
  getValue: (name: MusicAlbumEditForm1ViewTitleInputFieldName) => string,
  setValue: (name: MusicAlbumEditForm1ViewTitleInputFieldName, value: string) => void,
  getErrors: (name: MusicAlbumEditForm1ViewTitleInputFieldName) => FieldValidationErrorsType,
}) {
  const isMultipleOptions = [
    { title: '1曲のみ', value: '0' },
    { title: '2曲以上', value: '1' },
  ];
  return (
    <>
      <dl>
        <dt>
          { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
          <label htmlFor="/">
            このリリースに含める曲数
          </label>
        </dt>
        <dd>
          <CustomRadio
            options={isMultipleOptions}
            value={getValue('is_multiple')}
            setValue={(value) => setValue('is_multiple', value)}
            validationErrors={getErrors('is_multiple')}
          />
        </dd>
      </dl>
      {getValue('is_multiple') === '1' && (
        <>
          <dl>
            <dt>
              { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
              <label htmlFor="/">アルバムタイトル</label>
            </dt>
            <dd>
              <CustomTextInput
                placeholder="Frekul Release"
                value={getValue('title')}
                setValue={(value) => setValue('title', value)}
                validationErrors={getErrors('title')}
              />
              <p className="text_info_on">アルバムタイトルに「バージョン表記」「サブタイトル」「フィーチャリング表記」は使えません。</p>
            </dd>
          </dl>
          <dl>
            <dt>
              { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
              <label htmlFor="/">アルバムタイトル読み（ひらがな）</label>
            </dt>
            <dd>
              <CustomTextInput
                placeholder="ふりくるりりーす"
                value={getValue('title_kana')}
                setValue={(value) => setValue('title_kana', value)}
                validationErrors={getErrors('title_kana')}
              />
              <p className="text_info_off">ここに説明文</p>
            </dd>
          </dl>
          <dl>
            <dt>
              { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
              <label htmlFor="/">アルバムタイトル（英語）</label>
            </dt>
            <dd>
              <CustomTextInput
                placeholder="Frekul Release"
                value={getValue('title_en')}
                setValue={(value) => setValue('title_en', value)}
                validationErrors={getErrors('title_en')}
              />
              <p className="text_info_off">ここに説明文</p>
            </dd>
          </dl>
        </>
      )}
    </>
  );
}

